export default __webpack_public_path__ + "static/media/AllocationFinder-documentation.7dd5f6dc.md";